import { render, staticRenderFns } from "./CrmOwnerTransfer.vue?vue&type=template&id=2f255649"
import script from "./CrmOwnerTransfer.vue?vue&type=script&lang=js"
export * from "./CrmOwnerTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports